module.exports = __webpack_public_path__ + "static/media/talkTo-img.cf4ba7e8.png";